import PrivacyPolicy from './privacy-policy-view'
export default PrivacyPolicy
